<template>
  <div class="sidebar-logo-container" :class="{ collapse: collapse }">
    <el-tooltip class="item" effect="dark" content="回首页" placement="top">
    <transition name="sidebarLogoFade">
      <a
        v-if="collapse"
        key="collapse"
        class="sidebar-logo-link bbbb"
        :href="routerLink"
        @click="removeUser"
      >
        <!-- 缩小时只有一个logo -->
        <div
          v-if="collapse"
          class="logo-collapse"
          style="width: 100%; background-color: #1677FF"
        >
          <img :src="logoCombine" class="sidebar-logo" />
        </div>
        <h1 v-else class="sidebar-title">{{ title }}</h1>
      </a>
      <a @click="removeUser" v-else key="expand" class="sidebar-logo-link aaa" :href="routerLink">
        <!-- 展开时 -->
        <img v-if="logoUnfold" :src="logoUnfold" class="sidebar-logo" />
        <h1 v-else class="sidebar-title">{{ title }}</h1>
      </a>
    </transition>
  </el-tooltip>
  </div>
</template>

<script>
export default {
  name: "SidebarLogo",
  props: {
    collapse: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      title: this.$store.getters.opeInfo.title,
      logoCombine: require("@/assets/images/logo-top2.png"), // 左侧菜单合并时的logo
      logoUnfold: require("@/assets/images/login-04.png"), // 左侧菜单展开时的logo
      routerLink: process.env.VUE_APP_MEETYOU_EN_URL
      // favicon: this.$store.getters.opeInfo.favicon
    };
  },
  methods:{
    removeUser(){
      //localStorage.removeItem('userInfo')
    }
  }
};
</script>

<style lang="scss" scoped>
.logo-collapse {
  width: 44px;
  overflow: hidden;
  margin-left: 0;
}
.sidebarLogoFade-enter-active {
  transition: opacity 1.5s;
}

.sidebarLogoFade-enter,
.sidebarLogoFade-leave-to {
  opacity: 0;
}

.sidebar-logo-container {
  position: relative;
  width: 100%;
  height: 60px;
  line-height: 60px;
  text-align: center;
  overflow: hidden;
  > a {
    background-color: #1677ff !important;
  }

  & .sidebar-logo-link {
    height: 100%;
    width: 100%;

    & .sidebar-logo {
      width: 136px;
      height: 35px;
      vertical-align: middle;
      margin-right: 12px;
    }

    & .sidebar-title {
      display: inline-block;
      margin: 0;
      color: #fff;
      font-weight: 600;
      line-height: 60px;
      font-size: 14px;
      font-family: Avenir, Helvetica Neue, Arial, Helvetica, sans-serif;
      vertical-align: middle;
    }
  }

  &.collapse {
    .sidebar-logo {
      margin-right: 0px;
      width: auto;
    }
  }
}
</style>
